import { isPhoneValid } from './phone';
import { IRequestFormValues } from '../../../types/requestForm';

export const isValuesValid = (values: IRequestFormValues) => {
  return isPhoneValid(values.phone) && !!values.region;
};
